var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.uid}},[_c('LottiePlayer',{attrs:{"file":_vm.lottieOptions.file,"loop":_vm.lottieOptions.loop,"autoplay":_vm.lottieOptions.autoplay,"speed":_vm.lottieOptions.speed,"parent-uid":_vm.uid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }